import { ChatMultipleRegular } from "@fluentui/react-icons";
import { mergeStyles } from "@fluentui/merge-styles";
import { Avatar, Button, Tooltip } from "@fluentui/react-components";
import { ArrowUndoRegular } from "@fluentui/react-icons";
import { unfollowByConversation } from "../../../api/follow";
import { useMutation } from "@tanstack/react-query";
import useAuthContext from "../../../hooks/useAuthContext";
import { formatDate } from "../../../utils";
import FullPageLoader from "../../../components/loaders/FullPageLoader";
import LuggageTagText from "../../../components/LuggageTagText";
import { activityClass, childClass, childClass2, conversationClass, emptyStateClass, personaClass, personaContainerClass, scrollableStack, subjectClass } from "./styles";

import React, { useState } from "react";
import { appInsights } from "../../../ApplicationInsightsService";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../../components/Headings/PageHeader";
import { useNavigationContext } from "../../../contexts/navigationContext";
import {MailMultipleRegular} from "@fluentui/react-icons";

type FollowedConversationsProps = {
  data: any;
  isPending: boolean;
};

const FollowedConversations = ({ data, isPending }: FollowedConversationsProps) => {

  const { tokenData } = useAuthContext();
  const msUserId = tokenData.oid;
  const navigate = useNavigate();
  const { setFromPage } = useNavigationContext();



const [hiddenThreads, setHiddenThreads] = useState<{ [key: string]: boolean }>(() => {
  const stored = sessionStorage.getItem("hiddenThreads");
  return stored ? JSON.parse(stored) : {};
});


  const conversations = data?.conversations ?? [];

  const MoreItems = ({ count }: { count: number }) => (
    <span className={mergeStyles({ display: 'inline', marginLeft: '2px' })}>
      +{count}
    </span>
  );


const unfollowMutation = useMutation({
  mutationFn: async (conversationIds: string[]) => {
    return unfollowByConversation(msUserId, conversationIds);
  },
  onSuccess: (_, conversationIds) => {
    setHiddenThreads((prevHiddenThreads) => {
      const updated = {
        ...prevHiddenThreads,
        [conversationIds[0]]: true,
      };
      sessionStorage.setItem("hiddenThreads", JSON.stringify(updated));
      return updated;
    });
  },
});


const visibleConversations = conversations.filter(
  (thread) => !hiddenThreads[thread.conversationId]
);

  return isPending ? (
    <FullPageLoader title="Loading..." />
  ) : (
    <>
      {visibleConversations.length === 0 ? (
        <div className={emptyStateClass}>
          <strong>No followed conversations yet.</strong>
          <br />
          <br />
          Start following conversations to see them listed here.
        </div>
      ) : (
        <>
          <PageHeader headingText={"Followed Conversations"} icon={<MailMultipleRegular />} />
          <div className={scrollableStack}>
            {conversations.map((thread) =>

          !hiddenThreads[thread.conversationId] && (
            <React.Fragment key={thread.conversationId}>
              <div>
                <div className={conversationClass}>
                  <div className={activityClass}>{formatDate(new Date(thread.receivedDateTime))}</div>
                  <div className={subjectClass}><LuggageTagText text={thread.subject} /></div>
                  <div className={`childClass ${childClass}`}>
                    <Tooltip content="Unfollow" relationship="label" positioning="below">
                      <Button
                        appearance="subtle"
                        icon={<ArrowUndoRegular />}
                        onClick={() => unfollowMutation.mutate([thread.conversationId])}
                      />
                    </Tooltip>
                  </div>
                  <div className={personaContainerClass}>
                    {thread.conversationContacts.slice(0, 7).map((contact, index) => (
                      <Tooltip key={index} content={contact} relationship="label">
                        <Avatar name={contact} size={24} color="colorful" className={personaClass} />
                      </Tooltip>
                    ))}
                    {thread.conversationContacts.length > 7 && (
                      <MoreItems count={thread.conversationContacts.length - 7} />
                    )}
                  </div>
                  <div className={`childClass ${childClass2}`}>
                    <Tooltip content="Summarise" relationship="label" positioning="below">
                      <Button
                        appearance="subtle"
                        icon={<ChatMultipleRegular />}
                        onClick={() => {
                          appInsights.trackEvent({ name: "Button click: Following Summary" });
                          setFromPage(true);
                          navigate("/messageSummary", { state: { conversationId: thread.conversationId } });
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )
        )}
      </div>

        </>
      )}
    </>
  );
};


export default FollowedConversations;
